module.exports = __webpack_public_path__ + "assets/exclamação-roxo.7855a356.svg";